import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(2),
    maxWidth: 600,
    margin: '0 auto'
  },
  currentPlanBox: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    border: `4px solid ${theme.palette.success.main}`,
    borderRadius: theme.shape.borderRadius
  },
  alternativePlanBox: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius
  },
  currentPlanBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.success.dark,
    fontWeight: 600,
    '& svg': {
      fontSize: '1.2rem'
    }
  },
  planTitle: {
    fontSize: '1.25rem',
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary
  },
  planDescription: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.4
  },
  confirmDialog: {
    padding: theme.spacing(2)
  },
  featuresList: {
    listStyle: 'none',
    padding: 0,
    margin: theme.spacing(2, 0, 0, 0)
  },
  featureItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    '& svg': {
      marginRight: theme.spacing(1),
      fontSize: '0.5rem',
      color: theme.palette.primary.main
    }
  },
  textContent: {
    flex: 1,
    '& strong': {
      fontWeight: 'bold',
      display: 'inline'
    }
  },
  planPrice: {
    fontSize: '1.25rem',
    fontWeight: 700,
    color: theme.palette.primary.main
  }
}));
export default useStyles;